import { useState } from 'react';

// A link plus a copy button. Used for both links on the create screen, where
// copy-paste accuracy is the entire user journey — a truncated dashboard key is
// an unrecoverable test.
export function CopyableLinkField(input: { label: string; url: string; hint?: string; emphasis?: boolean }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(input.url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      // Clipboard API is unavailable or was refused. The input below is
      // selectable, so there is still a manual path — say nothing and let the
      // reader take it.
    }
  };

  return (
    <div className={input.emphasis ? 'linkField linkFieldEmphasis' : 'linkField'}>
      <label className="linkFieldLabel">{input.label}</label>
      <div className="linkFieldRow">
        <input type="text" readOnly value={input.url} onFocus={(event) => event.currentTarget.select()} />
        <button type="button" onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      {input.hint ? <p className="linkFieldHint">{input.hint}</p> : null}
    </div>
  );
}
